import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-ok",
  "use": "icon-icon-ok-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-icon-ok\"><path class=\"cls-1\" d=\"M474.18,792.88c-32.58,31.76-85.52,31.76-118.1,0L90.16,532.66c-32.58-31.76-32.58-83.89,0-115.65,32.58-31.76,85.52-31.76,118.1,0l206.88,202.39,398.68-390.54c32.58-31.76,85.52-31.76,118.1,0,32.58,31.76,32.58,83.89,0,115.65l-457.73,448.36h0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol